class Menu {

  constructor() {

    if (!this.setVars())
      return

    this.setEvents()

  }

  setVars() {

    this.section = document.querySelector('.mainNav')

    if (!this.section)
      return

    this.items = this.section.querySelectorAll('.mainNav__item')

    return true

  }

  setEvents() {

    const menuHover = (e) => {
      this.setSubmenuArrow(e.currentTarget)
    }

    this.items.each((item, index) => {

      item.addEventListener('mouseenter', menuHover)
      item.addEventListener('click',      menuHover)

    })

  }

  setSubmenuArrow(item) {

    const offset  = item.offsetLeft + (item.offsetWidth / 2)
    const submenu = item.querySelector('.mainNav__itemSubmenuArrow')

    if (!submenu)
      return

    submenu.style.transform       = 'translateX(' + offset + 'px)'
    submenu.style.webkitTransform = 'translateX(' + offset + 'px)'

  }

}